function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhiteTik(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9782",
    transform: "translate(-546 -186)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 3483",
    width: 20,
    height: 20,
    rx: 10,
    transform: "translate(546 186)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "check (2)",
    d: "m12 6-5.5 5.5L4 9",
    transform: "translate(548 187.5)",
    style: {
      fill: "none",
      stroke: "#01a685",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteTik);
export default __webpack_public_path__ + "static/media/whiteTik.c00c03f8df97f263d9244eb969975024.svg";
export { ForwardRef as ReactComponent };